module.exports = __webpack_public_path__ + "static_pc/img/ba08.42930bf4.png";